import React, {useState} from "react";
import sorro from "../../assets/image/stella/sorro.png";
import {AnimatePresence, motion} from "framer-motion";

const faqData = [
    {
        id: 1,
        question: "¿Qué es un crédito de Stella TV?",
        answer: "Un crédito equivale a un mes de servicio; por ejemplo, si compras 15 créditos y un cliente solicita una cuenta de un mes, se descontará 1 crédito de tu panle.\n" +
            "\n" +
            "También es importante saber que cada cuenta creada permite hasta (3-4) conexiones simultáneas, ya sea con la misma o diferente IP."
    },
    {
        id: 2,
        question: "¿Se puede recuperar un crédito que ya se uso?",
        answer: "No es posible. Una vez que utilizas un crédito para crear una cuenta, no podrás recuperarlo. Sin embargo, recuerda que la cuenta creada solo se activa cuando se utiliza en la app, lo que te permite aún recuperar el valor del crédito."
    },
    {
        id: 3,
        question: "¿Tienen fecha de vencimiento los créditos?",
        answer: "Los créditos no tienen fecha de vencimiento, por lo que no necesitas preocuparte si no los vendes en un mes. Puedes mantener tus créditos de Stella TV en tu panel de revendedor por el tiempo que desees."
    },
    {
        id: 4,
        question: "¿Cómo renovar las cuentas de mis clientes?",
        answer: "Desde tu panel, busca la cuenta que deseas renovar y selecciona el periodo de renovación que prefieras: 1 mes, 3 meses, 6 meses o un año."
    },
    {
        id: 5,
        question: "¿Qué pasa si termino de vender mis créditos?",
        answer: "Si has agotado tus créditos, necesitarás recargar. Recuerda que solo la persona que te vendió el panel puede realizar la recarga."
    },
    {
        id: 6,
        question: "¿Puedo renovar cualquier cuenta de Stella TV?",
        answer: "Solo puedes renovar las cuentas de tus propios clientes; no es posible renovar cuentas de usuarios que hayan comprado a otros revendedores."
    },
];

const AccordionItem = ({ i, expanded, setExpanded, question, answer }) => {
    const isOpen = i === expanded;

    return (
        <motion.div
            initial={false}
            className="mb-4 overflow-hidden rounded-lg bg-white  shadow-sm"
        >
            {/* Cabecera (Pregunta) */}
            <motion.header
                initial={false}
                onClick={() => setExpanded(isOpen ? false : i)}
                className={`flex cursor-pointer items-center text-black justify-between p-6 transition-colors duration-300 ${
                    isOpen
                        ? "bg-gradient-to-r from-orange-500 to-red-600 text-white" // Estilo Activo (Naranja)
                        : " text-gray-900 hover:bg-gray-50" // Estilo Inactivo (Blanco)
                }`}
            >
                <h3 className={`text-lg font-bold sm:text-xl font-sans ${
                    isOpen
                        ? "text-white" // Estilo Activo (Naranja)
                        : " text-gray-900 hover:text-[#eeb500]" // Estilo Inactivo (Blanco)
                }`} >{question}</h3>

                {/* Icono de flecha animado */}
                <motion.div
                    animate={{ rotate: isOpen ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                </motion.div>
            </motion.header>

            {/* Cuerpo (Respuesta) con Framer Motion */}
            <AnimatePresence initial={false}>
                {isOpen && (
                    <motion.section
                        key="content"
                        initial="collapsed"
                        animate="open"
                        exit="collapsed"
                        variants={{
                            open: { opacity: 1, height: "auto" },
                            collapsed: { opacity: 0, height: 0 }
                        }}
                        transition={{ duration: 0.3, ease: [0.04, 0.62, 0.23, 0.98] }}
                    >
                        <div className="border-t border-gray-100 bg-white p-6 text-gray-700 leading-relaxed">
                            {answer}
                        </div>
                    </motion.section>
                )}
            </AnimatePresence>
        </motion.div>
    );
};


const Section4 = () => {
    const [expanded, setExpanded] = useState(1);
    return (
        <div className="min-h-screen bg-[#111] px-6 py-20 text-white font-sans">
            <div className="mx-auto max-w-7xl">
                <div className="grid gap-12 lg:grid-cols-2 lg:gap-8">

                    {/* Columna Izquierda: Textos e Imagen */}
                    <div className="flex flex-col justify-start">
                        <span className="mb-2 text-yellow-500 font-bold uppercase tracking-wider">FAQ</span>
                        <h2 className="mb-6 text-5xl font-extrabold leading-tight uppercase">
                            Preguntas <br /> Frecuentes para reseller
                        </h2>
                        <p className="mb-8 text-gray-400 max-w-md text-lg">
                            Aquí tiene las respuestas a algunas dudas frecuentes que se tiene sobre
                            <span className="text-white font-semibold"> cómo comprar créditos, cómo ser vendedor de Stella TV</span> y mucho más.
                        </p>
                        <p className="mb-12 text-gray-400 text-lg">
                            Esperamos responder a todas ellas.
                        </p>

                        {/* Aquí va tu imagen del zorro */}
                        <div className="relative mt-auto w-full max-w-xs mx-auto lg:mx-0">
                            {/* Reemplaza src con tu importación real */}
                            <img
                                src={sorro}
                                alt="Mascota pensando"
                                className="w-full object-contain drop-shadow-2xl"
                            />
                        </div>
                    </div>

                    {/* Columna Derecha: Acordeón */}
                    <div className="flex flex-col justify-center">
                        {faqData.map((item) => (
                            <AccordionItem
                                key={item.id}
                                i={item.id}
                                expanded={expanded}
                                setExpanded={setExpanded}
                                question={item.question}
                                answer={item.answer}
                            />
                        ))}
                        <div>
                            <p>StellaTV usuario y contraseña gratis, generador cuentas Stella TV | Web oficial de Stella TV 2025</p>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default Section4;
